import styled from "styled-components"

export const MissingPageStyle=styled.div`

    .body{
        background-Color:hsl(30, 2%, 21%);
        display: flex;
        height: 100vh;
        width:100%;
        justify-content:center;
        flex-direction:column;
    }

    .img-logo{
        width:459px;
        height:175px;
        align-self:center;
    }

    .description{
        font-weight: 800;
        font-size: 2.2em;
        font-style: italic;
        margin: 2em 2em;
        color:white;
        font-family: "Inter var", sans-serif;
        align-self:center;
    }

    .text-notfound{
        font-weight: 800;
        font-size: 4em;
        font-style: italic;
        margin-bottom:1em;
        color:white;
        font-family: "Inter var", sans-serif;
        align-self:center;
    }


`